/**
 * 入力要素を取得
 * @param {string} type 物件種別
 * @returns {Object} 入力要素オブジェクト
 */
export const getInputElements = (type) => {
    const section = document.querySelector(
        `.js-ai-assessment__content-item[data-type="${type}"]`
    );
    if (!section) return {};

    return {
        zipcode: section.querySelector('input[name="estate_zip"]'),
        buildingArea: section.querySelector('input[name="building_area"]'),
        landArea: section.querySelector('input[name="land_area"]'),
        yearsOld: section.querySelector('input[name="years_old"]'),
    };
};

/**
 * すべてのDOM要素を取得
 * @returns {Object} DOM要素オブジェクト
 */
export const getAllElements = () => {
    return {
        pgHead: document.querySelector(".pg-head"),
        tabContainer: document.querySelector(".js-ai-assessment__content"),
        titleButtonsContainer: document.querySelector(
            ".js-ai-assessment__tabs"
        ),
        titleButtons: document.querySelectorAll(
            ".js-ai-assessment__tabs .js-ai-assessment__tab-title"
        ),
        contentSections: document.querySelectorAll(
            ".js-ai-assessment__content .js-ai-assessment__content-item"
        ),
        resultElement: document.querySelector(".pg-head-result__item strong"),
        hiddenInput: document.querySelector('input[name="estate_type"]'),
    };
};

/**
 * 他方のタブの入力要素を取得
 * @param {string} currentType 現在のタブタイプ
 * @param {string} fieldName フィールド名
 * @returns {HTMLElement|null}
 */
export const getOtherTabInput = (currentType, fieldName) => {
    const otherType = currentType === "house" ? "land" : "house";
    const otherSection = document.querySelector(
        `.js-ai-assessment__content-item[data-type="${otherType}"]`
    );
    return otherSection?.querySelector(`input[name="${fieldName}"]`) || null;
};

/**
 * コンテキストオブジェクトを作成
 * @param {string} type 物件種別
 * @param {HTMLElement} resultElement 結果表示要素
 * @returns {Object} コンテキストオブジェクト
 */
export const createContext = (type, resultElement) => {
    return {
        inputs: getInputElements(type),
        resultElement,
    };
};

/**
 * 両方のタブのコンテキストオブジェクトを作成
 * @param {HTMLElement} resultElement 結果表示要素
 * @returns {Object} コンテキストオブジェクト
 */
export const createContexts = (resultElement) => {
    return {
        house: createContext("house", resultElement),
        land: createContext("land", resultElement),
    };
};
